import { ListItemText } from "@mui/material";
import { useMemo, useCallback, memo, useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

import { useAlgolia } from "hooks";
import MegaMenuItemPresenter from "presenters/MegaMenuItemPresenter";

import { StyledList, StyledListItem, StyledListItemButton, StyledLink } from "./styles";

const LinkList = memo(({ list, mainMenuLinks, onLinkActiveChange }) => {
  const location = useLocation();
  const { clearAllFiltersByPath } = useAlgolia();
  const hasActiveLink = useMemo(() => {
    const currentPath = location.pathname;
    const matchingLink = list.find((link) => link.linkTo === currentPath);

    if (!matchingLink) return false;

    const conflictsWithMainMenu = mainMenuLinks.includes(matchingLink.linkTo);

    return !conflictsWithMainMenu;
  }, [list, location.pathname, mainMenuLinks]);

  const handleActiveChange = useCallback(
    (isActive) => {
      if (onLinkActiveChange) onLinkActiveChange(isActive);
    },
    [onLinkActiveChange],
  );

  useEffect(() => {
    handleActiveChange(hasActiveLink);
  }, [hasActiveLink, handleActiveChange]);

  const listItems = useMemo(
    () =>
      list.map((link) => (
        <StyledListItem key={link.name} id={link.name}>
          <StyledListItemButton>
            <StyledLink to={link.linkTo} onClick={() => clearAllFiltersByPath({ path: link.linkTo })}>
              <ListItemText>{link.name}</ListItemText>
            </StyledLink>
          </StyledListItemButton>
        </StyledListItem>
      )),
    [list],
  );

  return <StyledList>{listItems}</StyledList>;
});

LinkList.propTypes = {
  list: PropTypes.arrayOf(MegaMenuItemPresenter.shape()),
  mainMenuLinks: PropTypes.arrayOf(PropTypes.string),
  onLinkActiveChange: PropTypes.func,
};

export default LinkList;
